export const SIZE_GUIDES = {
  "bella-canvas-3001": {
    name: "Bella+Canvas 3001 Unisex Jersey Tee",
    note: "Manufacturer measurements, garment laid flat. Width is measured across the chest 1\" below the armhole; length from the high point of the shoulder to the hem. Tolerance ±1\".",
    rows: [
      ["XS", 27, 16.5], ["S", 28, 18], ["M", 29, 20], ["L", 30, 22], ["XL", 31, 24],
      ["2XL", 32, 26], ["3XL", 33, 28], ["4XL", 34, 30], ["5XL", 35, 32],
    ],
  },
};
